import {DictionaryItem, DictionaryItemListing, DictionaryType, UpdateDictionaryItem,} from '../types/DictionaryItem';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

const URL = '/dictionary-items';

const dictionaryItemsService = {
  getDictionaryItemsByType: (type: DictionaryType) =>
    handleError(
      () => httpClient.get<DictionaryItemListing[]>(`${URL}/${type}`),
      'Error fetching dictionary items:'
    ),

  getDictionaryItem: (type: DictionaryType, alias: string) =>
    handleError(
      () => httpClient.get<DictionaryItem>(`${URL}/${type}/${alias}`),
      'Error fetching dictionary item:'
    ),

  createDictionaryItem: (type: DictionaryType, dictionaryItem: UpdateDictionaryItem) =>
    handleError(
      () => httpClient.post<void>(`${URL}/${type}`, dictionaryItem),
      'Error creating dictionary item:'
    ),

  updateDictionaryItem: (type: DictionaryType, alias: string, dictionaryItem: UpdateDictionaryItem) =>
    handleError(
      () => httpClient.put<void>(`${URL}/${type}/${alias}`, dictionaryItem),
      'Error updating dictionary item:'
    ),

  deleteDictionaryItem: (type: DictionaryType, alias: string) =>
    handleError(
      () => httpClient.delete<void>(`${URL}/${type}/${alias}`),
      'Error deleting dictionary item:'
    ),
};

export default dictionaryItemsService;
